import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';
interface RevealProps {
  children: ReactNode;
  delay?: number;
  className?: string;
}
export function Reveal({
  children,
  delay = 0,
  className
}: RevealProps) {
  return <motion.div className={className} initial={{
    opacity: 0,
    y: 28
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.8,
    delay,
    ease: 'easeOut'
  }} data-id="element-151" data-mp="3bi5wa5v5c6hm">
      {children}
    </motion.div>;
}